<!--
 * @Description: 
 * @Version: 2.0
 * @Autor: sen.yang
 * @Date: 2022-04-26 15:15:24
 * @LastEditors: sen.yang
 * @LastEditTime: 2022-04-26 17:20:41
-->
<template>
	<div class="component">
		<div class="label">
			<p style="flex:1">
				{{ question.name }}
				<span v-if="question.mustAnswer" class="required">*</span>
			</p>
			<p v-if="!question.hideAdd&&!disabled " class="add_button" @click="add"
				><van-icon class="text-primary" name="add" /> 添加药品</p
			>
		</div>
		<van-cell-group
			class="field_row"
			v-for="(questionTeam, questionTeamIndex) in question.optionList"
			:key="questionTeamIndex"
		>
			<van-field
				v-for="(option, index) in questionTeam"
				:key="index"
				v-model="option.value"
				:rules="option.mustAnswer ? rule : []"
				:label="option.name"
				placeholder="请输入"
				@input="change"
				:error-message-align="option.textAlign||'right'"
				:input-align="option.textAlign||'right'"
				:disabled="disabled"
				:maxlength="option.verifyMax"
				:readonly="option.type === 'picker'"
				@click="showPicker(index,questionTeamIndex,option)"
			>
				<template #button>
					<span style="color:#323233"> {{ option.suffixName }}</span>
				</template>
			</van-field>
			<div class="bottom_button" v-if="question.optionList.length >1 " @click="deleteItem(questionTeamIndex)">
				<div class="button_style"><van-icon name="delete-o" /> 删除药品</div>
			</div>
		</van-cell-group>

		<g-question-description v-model="show" :list="list" />

		<van-popup v-model="showPickerCard" position="bottom">
			<van-picker
				title="请选择"
				show-toolbar
				:columns="columns"
				@confirm="onConfirmPicker"
				@cancel="showPickerCard = false"
			/>
		</van-popup>
	</div>
</template>

<script>
import GQuestionDescription from "./GQuestionDescription.vue";
export default {
    name: 'GFuse',
    components: { GQuestionDescription },
    props: ['question', 'value', 'option', 'rule', 'disabled'],
    model: {
        prop: 'value',
        event: 'customInput'
    },
    computed: {
        list () {
            return this.question.remark.split('\n')
        }
    },
    data () {
        return {
            show: false,
            showPickerCard: false,
            pickerVal: '',
            columns: [],
            selectIndex: '',
            selectOptionIndex: '',
        }
    },
    methods: {
        change () {
            this.$emit('change')
        },
        add () {
            let list = JSON.parse(JSON.stringify(this.question.optionList))
            if (list.length > 0) {
                let arr = list[0].map(v => ({ ...v, value: '' }))
                this.question.optionList.push(arr)
                console.log(this.question.optionList)
            }

        },
        showPicker (index, optionIndex, item) {
            if (item.type !== 'picker') {
                return
            }
            this.showPickerCard = true
            this.selectIndex = index
            this.selectOptionIndex = optionIndex
            this.pickerVal = item.val || ''
            this.columns = item.columns
        },
        onConfirmPicker (val) {
            this.showPickerCard = false
            this.question.optionList[this.selectOptionIndex][this.selectIndex].value = val
        },
        deleteItem (index) {
            this.question.optionList.splice(index, 1)
        }
    }
}
</script>

<style lang="less" scoped>
@import './base.less';

.component {
	.label {
		display: flex;
		justify-content: space-between;
		.add_button {
			font-weight: 400;
			font-size: 28px;
			width: 160px;
			text-align: right;
		}
	}
	.field_row {
		border-radius: 16px;
		overflow: hidden;
		margin-bottom: 26px;
	}
	.van-cell {
		padding: 28px;
		border-radius: 16px;
		overflow: hidden;
		font-size: 32px;
	}

	.input_label {
		color: @gray-9;
		font-size: 26px;
		margin-bottom: 12px;
	}

	.m-b-5 {
		margin-bottom: 32px;
	}
}
.bottom_button {
	.button_style {
		border: 1px solid @primary;
		width: 240px;
		height: 74px;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 28px;
		color: @primary;
		margin: 28px auto 30px auto;
		border-radius: 40px;
	}
}
</style>
